module.exports = __webpack_public_path__ + "media/warranty-claim/nailing-zone-be18874d.svg";